import type { Icon } from './icon'

import { isPlatformBrowser } from '@angular/common'
import {
  Directive,
  effect,
  ElementRef,
  inject,
  input,
  numberAttribute,
  PLATFORM_ID,
} from '@angular/core'

@Directive({
  selector: 'svg[ngxi]',
  standalone: true,
})
export class Ngxi {
  private readonly el = inject(ElementRef<SVGElement>)
  private readonly platformId = inject(PLATFORM_ID)

  readonly icon = input.required<Icon>()

  readonly width = input(undefined, {
    transform: numberAttribute,
  })

  readonly height = input(undefined, {
    transform: numberAttribute,
  })

  readonly viewBox = input<string>()

  constructor() {
    effect(() => {
      this.updateSvg()
    })
  }

  private updateSvg(): void {
    if (isPlatformBrowser(this.platformId)) {
      const svg = this.el.nativeElement

      svg.innerHTML = ''

      if (!this.icon) {
        return
      }

      svg.innerHTML = this.icon().body

      svg.setAttribute(
        'width',
        (this.width() ?? this.icon()?.width ?? '').toString(),
      )

      svg.setAttribute(
        'height',
        (this.height() ?? this.icon()?.height ?? '').toString(),
      )

      svg.setAttribute(
        'viewBox',
        this.viewBox() ?? this.icon()?.viewBox ?? '',
      )
    }
  }
}
